'use strict';
import angular from 'angular';
import './scripts/rulesets.ctrls';

import routingRuleSetHtmlUrl from './views/routingRuleSet.html';
import tapIORuleSetHtmlUrl from './views/tapIORuleSet.html';

angular.module('rulesets', [
    'rulesets.ctrls'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('routingRuleSet', {
                parent: 'layout',
                url: '/admin/routingRuleSet/:id',
                templateUrl: routingRuleSetHtmlUrl,
                controller: 'RoutingRuleSetController',
            })
            .state('ruleSet', {
                parent: 'layout',
                url: '/admin/tapIORuleSet',
                templateUrl: tapIORuleSetHtmlUrl,
                controller: 'TapIORuleSetController',
            })
    }]);